import { createFileRoute, redirect } from "@tanstack/react-router";

/** Preserve every incoming quiz URL while opening that exact question in Play. */
export const Route = createFileRoute("/quiz/$slug")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/play", search: { quiz: params.slug }, statusCode: 301 });
  },
  component: () => null,
});
